import { ForwardRefExoticComponent, RefObject } from "react";
import DialogComponent, { DialogRef, DialogProps } from "../DialogComponent";
import Alert, { AlertProps } from "./Alert";
import Confirm, { ConfirmProps, ConfirmPropsResult } from "./Confirm";

export interface DialogComponent<P = {}> extends ForwardRefExoticComponent<P> {
  ref: RefObject<DialogRef>;
  alert: (options: AlertProps) => Promise<void>;
  confirm: (options: ConfirmProps) => Promise<ConfirmPropsResult>;
}

const Dialog = DialogComponent as DialogComponent<DialogProps>;
Dialog.alert = Alert;
Dialog.confirm = Confirm;

export default Dialog;
